import { render } from "./BaseDatalist.vue?vue&type=template&id=0c05387e"
import script from "./BaseDatalist.vue?vue&type=script&lang=js"
export * from "./BaseDatalist.vue?vue&type=script&lang=js"
script.render = render

export default script